import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ProgramVersionItemDto } from '../../api/types/dtos/program';

interface ItemDetailsModalProps {
  open: boolean;
  onClose: () => void;
  item: ProgramVersionItemDto | null;
}

export const ItemDetailsModal: React.FC<ItemDetailsModalProps> = ({
  open,
  onClose,
  item
}) => {
  if (!item) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Detalles del Criterio</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          <strong>Número:</strong> {item.cpNumber}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <strong>Nombre:</strong> {item.name}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <strong>Descripción:</strong>
        </Typography>
        <Typography variant="body1">
          {item.description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemDetailsModal; 